import service from './axios';

// 获取用户信息
export const listAllBot = () => {
    return service.get('/bot/list');
};

export const bind = (bot_type, phone_number, sn) => {
    return service.post('/bot/bind', {
            bot_type: bot_type,
            phone_number: phone_number + "",
            sn: sn + "",
        }
    );
};

export const unbind = (bot_id) => {
    return service.post('/bot/unbind', {
            bot_id: bot_id
        }
    );
};

export const get_unadded_observation_bot_count = () => {
    return service.get('/bot/get_unadded_observation_bot_count');
};



export const autoAddObservationBot = () => {
    return service.post('/bot/autoAddObservationBot');
};

// 更新用户信息
export const profitOverview = (bot_id, date) => {
    return service.get('/bot/profitoverview', {
        params: {
            bot_id: bot_id,
            date: date
        }
    });
};

export const profitOverviewCustomDate = (bot_id, date, startTime, endTime) => {
    return service.get('/bot/profitoverview', {
        params: {
            bot_id: bot_id,
            date: date,
            start_time: startTime,
            end_time: endTime
        }
    });
};

export const profitdetails = (bot_id, date) => {
    return service.get('/bot/profitdetails', {
        params: {
            bot_id: bot_id,
            date: date
        }
    });
};

export const profitdetailsCustomDate = (bot_id, date, startTime, endTime) => {
    return service.get('/bot/profitdetails', {
        params: {
            bot_id: bot_id,
            date: date,
            start_time: startTime,
            end_time: endTime
        }
    });
};

export const profitdetailslist = (bot_id, date, price_currency, page, sortField, sortOrder) => {
    return service.get('/bot/profitdetailslist', {
        params: {
            bot_id: bot_id,
            date: date,
            price_currency: price_currency,
            page: page,
            sort_field: sortField,
            sort_order: sortOrder
        }
    });
};

export const profitdetailslistCustomDate = (bot_id, date, price_currency, startTime, endTime, page, sortField, sortOrder) => {
    return service.get('/bot/profitdetailslist', {
        params: {
            bot_id: bot_id,
            date: date,
            price_currency: price_currency,
            start_time: startTime,
            end_time: endTime,
            page: page,
            sort_field: sortField,
            sort_order: sortOrder
        }
    });
};

export const get_daily_usdt_profit_last7 = (bot_type) => {
    return service.get('/bot/get_daily_usdt_profit_last7', {
        params: {
            bot_type: bot_type
        }
    });
};


export const get_7days_profit_stats = (bot_type) => {
    return service.get('/bot/get_7days_profit_stats', {
        params: {
            bot_type: bot_type
        }
    });
};


export const get_daily_usdt_profit_range = (bot_type, date) => {
    return service.get('/bot/get_daily_usdt_profit_range', {
        params: {
            bot_type: bot_type,
            date: date
        }
    });
};

export const get_daily_usdt_profit_range_custom_date = (bot_type, date, startTime, endTime) => {
    return service.get('/bot/get_daily_usdt_profit_range', {
        params: {
            bot_type: bot_type,
            date: date,
            start_time: startTime,
            end_time: endTime
        }
    });
};


export const get_top_bots_by_usdt_profit = (bot_type, date) => {
    return service.get('/bot/get_top_bots_by_usdt_profit', {
        params: {
            bot_type: bot_type,
            date: date
        }
    });
};

export const get_top_bots_by_usdt_profit_custom_date = (bot_type, date, startTime, endTime) => {
    return service.get('/bot/get_top_bots_by_usdt_profit', {
        params: {
            bot_type: bot_type,
            date: date,
            start_time: startTime,
            end_time: endTime
        }
    });
};




export const get_top_symbol_by_usdt_profit = (bot_type, date) => {
    return service.get('/bot/get_top_symbols_by_usdt_profit', {
        params: {
            bot_type: bot_type,
            date: date
        }
    });
};

export const get_top_symbol_by_usdt_profit_custom_date = (bot_type, date, startTime, endTime) => {
    return service.get('/bot/get_top_symbols_by_usdt_profit', {
        params: {
            bot_type: bot_type,
            date: date,
            start_time: startTime,
            end_time: endTime
        }
    });
};

// ----- 订单排行榜 - 数额变动
export const get_top_order_record = (bot_type, date, order_by) => {
    return service.get('/bot/get_top_order_record', {
        params: {
            bot_type: bot_type,
            date: date,
            order_by: order_by
        }
    });
};

export const get_top_order_record_custom_date = (bot_type, date, order_by, startTime, endTime) => {
    return service.get('/bot/get_top_order_record', {
        params: {
            bot_type: bot_type,
            date: date,
            start_time: startTime,
            end_time: endTime,
            order_by: order_by
        }
    });
};


export const get_selected_price_currency = () => {
    return service.get('/bot/get_selected_price_currency');
};


export const get_daily_usdt_profit_last7_observation = (bot_type) => {
    return service.get('/bot/get_daily_usdt_profit_last7_observation', {
        params: {
            bot_type: bot_type
        }
    });
};


export const get_observation_info = (bot_type) => {
    return service.get('/bot/get_observation_info', {
        params: {
            bot_type: bot_type
        }
    });
};


export const get_profit_rolling_show_data = (bot_type) => {
    return service.get('/bot/get_profit_rolling_show_data', {
        params: {
            bot_type: bot_type
        }
    });
};

export const updateBotRemark = (bot_id, remark) => {
    return service.post('/bot/update_remark', {
        bot_id: bot_id,
        remark: remark
    });
}
